import { type MoleculeScope, type ScopeTuple, useScopes } from "bunshi/react"

// Returns the value of the scope context for the given scope or undefined if the scope is not present.
export const useScopeContextValue = <T>(scope: MoleculeScope<T>): T | undefined => {
  const scopeTuples = useScopes()
  // First value in tuple is the scope object, second value is the value of the scope
  const tuple = scopeTuples.find(([s]) => s === scope)

  return tuple ? (tuple as ScopeTuple<T>)[1] : undefined
}
